export const SET_AVAILABILITY = 'vegas/SET_AVAILABILITY';
export const GET_LOBBY_VIEWS = 'vegas/GET_LOBBY_VIEWS';
export const GET_LOBBIES = 'vegas/GET_LOBBIES';
export const REQUEST_LOBBIES = 'vegas/REQUEST_LOBBIES';
export const SET_LOBBIES = 'vegas/SET_LOBBIES';
export const SET_LOBBIES_BY_PRODUCT = 'vegas/SET_LOBBIES_BY_PRODUCT';
export const GET_GAME_REAL_MODE = 'vegas/GET_GAME_REAL_MODE';
export const SET_GAME_REAL_MODE = 'vegas/SET_GAME_REAL_MODE';
export const SET_GAME_REAL_MODE_ERROR = 'vegas/SET_GAME_REAL_MODE_ERROR';
export const RESET_GAME_REAL_MODE_URL = 'vegas/RESET_GAME_REAL_MODE_URL';
export const SET_CASINO_BANNERS = 'vegas/SET_CASINO_BANNERS';
export const SET_CASINO_VISIBILITY_RESTRICTED = 'vegas/SET_CASINO_VISIBILITY_RESTRICTED';

export const setAvailability = (payload = true) => ({
  type: SET_AVAILABILITY,
  payload,
});

export const getLobbyViews = (payload = {}) => ({
  type: GET_LOBBY_VIEWS,
  payload,
});

export const getLobbies = (product, options = {}) => ({
  type: GET_LOBBIES,
  payload: product,
  options
});

export const requestLobbies = (product) => ({
  type: REQUEST_LOBBIES,
  payload: product
});

export const setLobbies = (data = {}) => ({
  type: SET_LOBBIES,
  payload: data
});

export const setLobbiesByProduct = (lobbies = {}) => ({
  type: SET_LOBBIES_BY_PRODUCT,
  payload: lobbies
});

export const getGameRealMode = (payload = {}) => ({
  type: GET_GAME_REAL_MODE,
  payload
});

export const setGameUrl = (payload) => ({
  type: SET_GAME_REAL_MODE,
  payload
});

export const setGameUrlError = (error = '') => ({
  type: SET_GAME_REAL_MODE_ERROR,
  payload: error
});

export const resetGameRealModeUrl = () => ({
  type: RESET_GAME_REAL_MODE_URL
});

export const setCasinoBanners = (payload) => ({
  type: SET_CASINO_BANNERS,
  payload
});

export const setCasinoVisibilityRestricted = (status) => ({
  type: SET_CASINO_VISIBILITY_RESTRICTED,
  payload: status
});
